// Set webpack public path
__webpack_public_path__ = document.head.querySelector('meta[name="base_assets"]').content

import "./src/mobile-widgets"
import "./src/visible-header-height"
import "./src/active-filters"
import "./src/facet-pager-scroll"
import "./src/monitor-header"

import {HadronCollider} from "@webreact/webreactor"

document.body.classList.add("js")

const router = new HadronCollider([
    {
        file: async() => (await import("./components/single-product/color-variations")).default,
        target: ".ux-swatches-attribute-ux_image",
    },
    {
        file: async() => (await import("./components/single-product/sticky-add-to-cart")).default,
        target: ".single-product",
    },
    {
        file: async() => (await import("./components/single-product/reviews")).default,
        target: ".woocommerce-Reviews",
    },
    {
        file: async() => (await import("./components/single-product/dynamic-pricing")).default,
        target: "[data-component=dynamic-pricing]",
    },
    {
        file: async() => (await import("./components/global/read-more")).default,
        target: ".read-more-mobile",
    },
    {
        file: async() => (await import("./components/global/chat")).default,
        target: ".single-product",
    },
    {
        file: async() => (await import("./components/global/stock-status")).default,
        target: ".stock-status",
    },
    {
        target: "[data-component=facet-apply]",
        file: async() => (await import("./components/archive-product/facet-apply")).default,
    },
    {
        target: ".accordion",
        file: async() => (await import("./components/global/accordion")).default,
    },
    {
        target: ".woocommerce-checkout",
        file: async() => (await import("./components/checkout/fields")).default,
    },
])

router.run()